import { FinalValuation } from '@popety-io/types'

type PublicEstimateValueEdited = {
  finalValuation?: FinalValuation
  lowRange?: number | string
  price?: number | string
  priceMin?: number | string
  priceMax?: number | string
  upperRange?: number | string
}

const toNumber = (value?: number | string): number | undefined => {
  if (value === undefined || value === '') return undefined

  const parsedValue = Number(value)
  return Number.isFinite(parsedValue) ? parsedValue : undefined
}

export const getPublicFinalValuation = (
  valueEdited?: PublicEstimateValueEdited | null
): FinalValuation | null => {
  if (!valueEdited?.price && !valueEdited?.finalValuation) {
    return null
  }

  return {
    value: toNumber(valueEdited.price ?? valueEdited.finalValuation?.value),
    range: valueEdited.finalValuation?.range || {
      min: toNumber(valueEdited.lowRange ?? valueEdited.priceMin),
      max: toNumber(valueEdited.upperRange ?? valueEdited.priceMax),
    },
  }
}
